import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { SortPageSizePair } from '@/components/Pagination/hammer-pagination/SortPageSizePair';
import { savedItemSortOrders } from '@/enums';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getSavedItemsPagination } from '@/redux/modules/item/saved/savedItems.selectors';
import { changePaginationPageSize } from '@/redux/modules/pagination';
import { SearchSortAndDirection } from '@/types/search/enums/sortTypes';
import { toQueryString } from '@/utils/urls';

import validateMyFavoritesPageParams from '../../helpers/validateMyFavoritesPageParams';
import { MyFavoritesPageQueryParams } from '../../types/MyFavoritesPage.types';

const MyFavoritesSlideMenu = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { keyword, page, pageSize, sort, status, totalRecords } = useAppSelector(getSavedItemsPagination);

    const onChange = (param: MyFavoritesPageQueryParams) => {
        const newParams = validateMyFavoritesPageParams({
            pageSize,
            status,
            ...param,
        });
        if (typeof newParams.pageSize !== 'undefined') {
            dispatch(changePaginationPageSize(newParams.pageSize));
        }
        navigate({ search: toQueryString(newParams) });
    };

    const onFilterChange = (filters) => {
        onChange(filters);
    };

    const sortOptions = React.useMemo(
        () =>
            savedItemSortOrders.map((key: SearchSortAndDirection) => {
                let value = key;
                if (status === 'ended') {
                    if (key === SearchSortAndDirection.TimeMostRecent) {
                        // ? fix referenced in `sortTypes` (OLD vs NEW)
                        value = SearchSortAndDirection.TimeOldest;
                    }
                    if (key === SearchSortAndDirection.TimeNewest) {
                        value = SearchSortAndDirection.TimeMostRecent;
                    }
                } else {
                    if (key === SearchSortAndDirection.TimeMostRecent) {
                        value = SearchSortAndDirection.TimeStartingSoonest;
                    }
                    if (key === SearchSortAndDirection.TimeNewest) {
                        value = SearchSortAndDirection.TimeStartingFurthest;
                    }
                }
                return {
                    label: <FormattedMessage id={`sorts.${value}`} />,
                    value: key,
                };
            }),
        [status]
    );

    return (
        <div>
            <BodySecondary>
                <FormattedMessage
                    id="search_alerts.count_terms"
                    values={{ count: totalRecords }}
                />
            </BodySecondary>
            <SortPageSizePair
                className="mt-sm flex-col"
                onChange={onFilterChange}
                paginationFilter={{
                    keyword,
                    page,
                    pageSize,
                    sort,
                    status,
                    totalRecords,
                }}
                shouldModifyQueryParams
                sortOptions={sortOptions}
            />
        </div>
    );
};

export default MyFavoritesSlideMenu;
